interface ChipColors {
  bg: string;
  text: string;
}

/**
 * The kit's certification badge pairs, keyed by the label the organizers use. Colour is not a
 * column on the certification type, so anything renamed or newly added falls back to the neutral
 * chip rather than to a colour nobody chose — which is the right way round for a list organizers
 * are free to edit (CNT-05).
 */
const COLORS: Record<string, ChipColors> = {
  'Women-owned': { bg: '#EEF4F3', text: '#3E5654' },
  'Minority-owned': { bg: '#EEECF1', text: '#4A4257' },
  Government: { bg: '#E9EEF1', text: '#3C5261' },
  'State or local': { bg: '#F3EEE7', text: '#6B5433' },
};

const NEUTRAL: ChipColors = { bg: '#F2F1EC', text: '#3D3B36' };

export function certificationColors(label: string): ChipColors {
  return COLORS[label] ?? NEUTRAL;
}
